import { FC, ReactNode } from "react";
import { Header } from "./Header";

type Props = {
  children: ReactNode;
  mainText: string;
  t?: (key: string) => string;
};

const FrameBody: FC<Props> = ({ children, mainText, t }) => {
  return (
    <div
      className="bg-white py-6 sm:py-12 px-4 sm:px-8 rounded-[16px]"
      style={{ boxShadow: "0px 4px 8px 0px #00000026" }}
    >
      <Header mainText={mainText} />
      <div className="mt-8">{children}</div>

      <div className="mt-12">
        <p className="text-[#031F47] font-semibold mb-2">{t ? t("need_help") : "Need help?"}</p>
        <a
          href="tel:+49308561214800"
          className="flex items-center w-max gap-2 text-[#031F47] hover:opacity-70 transition-opacity duration-200"
        >
          <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.44476 16.4435L8.43651 16.445L8.38326 16.4712L8.36826 16.4742L8.35776 16.4712L8.30451 16.445C8.29651 16.4425 8.29051 16.4437 8.28651 16.4487L8.28351 16.4562L8.27076 16.7772L8.27451 16.7922L8.28201 16.802L8.36001 16.8575L8.37126 16.8605L8.38026 16.8575L8.45826 16.802L8.46726 16.79L8.47026 16.7772L8.45751 16.457C8.45551 16.449 8.45126 16.4445 8.44476 16.4435ZM8.64351 16.3587L8.63376 16.3602L8.49501 16.43L8.48751 16.4375L8.48526 16.4457L8.49876 16.7682L8.50251 16.7772L8.50851 16.7825L8.65926 16.8522C8.66876 16.8547 8.67601 16.8527 8.68101 16.8462L8.68401 16.8357L8.65851 16.3752C8.65601 16.3662 8.65101 16.3607 8.64351 16.3587ZM8.10726 16.3602C8.10395 16.3582 8.1 16.3576 8.09623 16.3584C8.09246 16.3592 8.08915 16.3615 8.08701 16.3647L8.08251 16.3752L8.05701 16.8357C8.05751 16.8447 8.06176 16.8507 8.06976 16.8537L8.08101 16.8522L8.23176 16.7825L8.23926 16.7765L8.24226 16.7682L8.25501 16.4457L8.25276 16.4367L8.24526 16.4292L8.10726 16.3602Z"
              fill="#031F47"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.414 15.5997C10.334 15.56 7.27325 15.137 4.06775 11.9322C0.863 8.72673 0.44075 5.66673 0.40025 4.58598C0.34025 2.93898 1.60175 1.33923 3.059 0.714479C3.23448 0.638704 3.42665 0.609854 3.61665 0.63076C3.80664 0.651666 3.98794 0.72161 4.14275 0.833729C5.34275 1.70823 6.17075 3.03123 6.88175 4.07148C7.03819 4.30003 7.10508 4.57814 7.06967 4.85283C7.03426 5.12751 6.89903 5.37957 6.68975 5.56098L5.2265 6.64773C5.15581 6.69878 5.10604 6.77375 5.08646 6.85872C5.06687 6.94369 5.07879 7.03288 5.12 7.10973C5.4515 7.71198 6.041 8.60898 6.716 9.28398C7.391 9.95898 8.33075 10.5875 8.975 10.9565C9.05578 11.0018 9.15086 11.0145 9.24069 10.9919C9.33053 10.9693 9.40829 10.9131 9.458 10.835L10.4105 9.38523C10.5856 9.15261 10.8439 8.99678 11.1314 8.95037C11.4188 8.90395 11.7131 8.97055 11.9525 9.13623C13.0078 9.86673 14.2393 10.6805 15.1407 11.8347C15.262 11.9907 15.3391 12.1763 15.364 12.3722C15.389 12.5681 15.3608 12.7672 15.2825 12.9485C14.6547 14.4132 13.0662 15.6605 11.414 15.5997Z"
              fill="#031F47"
            />
          </svg>
          {t ? t("call_us") : "Call us"} +49 30 856 1214 800
        </a>
      </div>
    </div>
  );
};

export { FrameBody };
